<template>
  <div class="relative">
    <input
      :type="type"
      :placeholder="placeholder"
      :class="cssClass"
      :id="getId"
      :value="modelValue"
      @input="handlerInput"
      :disabled="disabled"
      :autofocus="autofocus"
      @change="handlerFile"
      @focusout="handleFocusOut"
      @keydown="keyPressHandler"
    />
    <small v-if="!valid" class="c-red-a700 position-absolute">{{
      errorMessage
    }}</small>
  </div>
</template>

<script>
import validator from "validate.js";
import helper from "Resources/util/helper.js";
import { message } from "Resources/plugins/i18n";
import localeChange from "Core/mixins/localeChange";
import { getMessage, locale } from "Resources/plugins/i18n";

export default {
  name: "Input",

  mixins: [localeChange],

  emits: ["update:modelValue"],

  props: {
    name: {
      default: "",
      type: String,
      required: false,
    },
    type: {
      default: "text",
      type: String,
      required: false,
    },
    placeholder: {
      default: "",
      type: String,
      required: false,
    },
    classes: {
      default: "",
      type: String,
      required: false,
    },
    id: {
      default: "",
      type: String,
      required: false,
    },
    modelValue: {
      default: "",
      type: [Number, String],
      required: false,
    },
    event: {
      default: "",
      type: String,
      required: false,
    },
    callback: {
      default: null,
      type: Function,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
    autofocus: {
      default: false,
      type: Boolean,
      required: false,
    },
    data: {
      default: () => {},
      type: Object,
      required: false,
      description: "to use with callback function",
    },
    rule: {
      default: () => {},
      type: Object,
      required: false,
      description: "for validation rule",
    },
    forConfirm: {
      default: "",
      type: String,
      required: false,
      description: "for use to confirm password if input is confirm password",
    },
    check: {
      default: "",
      type: [Number, String, Array],
      required: false,
      description: "to trigger validation method",
    },
    length: {
      default: 0,
      type: Number,
      required: false,
      description: "Limit of input text length 0 == no limit",
    },
    filterChars: {
      default: ["/", "\\"],
      type: [Array],
      required: false,
      descript:
        "Some characters interference mobile routing and some decoding process",
    },
  },

  data() {
    return {
      valid: true,
      errorMessage: "",
      locale: "mm",
      lastKey: "",
      // helper: helper,
    };
  },

  watch: {
    /**
     * check prop က parent ရဲ့ validation ရလဒ်ဖြစ်တယ်။ user က input မရိုက်ဘဲ
     * "Next" / "Submit" နှိပ်လိုက်တဲ့အခါ parent က check ကို ပြောင်းပေးလိုက်ရင်
     * ဒီ field ရဲ့ error message ပေါ်ဖို့ လိုတယ်။
     *
     * ဘာကြောင့် watcher လိုသလဲ — validate() က handlerInput (input event) ထဲကနေဘဲ
     * ခေါ်ထားတာမို့ တစ်ခါမှ မရိုက်ရသေးတဲ့ field တွေ (ဥပမာ phone) မှာ
     * error message လုံးဝ မပေါ်ခဲ့ဘူး။ m-select မှာတော့ ဒီ watcher ရှိပြီးသားမို့
     * သူ့ message တွေချည်း ပေါ်နေတာ။
     */
    check: {
      deep: true,
      handler(value) {
        /**
         * parent က check ကို ရှင်းလိုက်တဲ့အခါ (form reset / slider ပိတ်လိုက်တာ) မှာတော့
         * error ကို ဖျောက်ရုံပဲ လုပ်ရမယ် — validate() ကို ပြန်မခေါ်ရဘူး။
         * ဘာကြောင့်လဲ — reset ပြီးတဲ့အခါ field တွေက empty ဖြစ်နေတာမို့ ပြန်စစ်လိုက်ရင်
         * required error တွေ ချက်ချင်း ပြန်ပေါ်လာပြီး user တစ်ခါမှ မထိရသေးတဲ့ form မှာ
         * အနီစာလုံးတွေ ကျန်နေတယ် (content piece slider ကို ဒုတိယအကြိမ် ဖွင့်ချိန်)။
         */
        if (this.isCheckCleared(value)) {
          this.valid = true;
          this.errorMessage = "";

          return;
        }

        this.validate(this.normalizeValue(this.modelValue));
      },
    },
  },

  computed: {
    cssClass() {
      // let className = ["shadow-sm focus:outline-none focus-visible:ring-red-500 focus:ring-red-500 focus:border-red-500 px-2 py-2 border w-full border-gray-300 rounded-md"];
      let className = [
        "shadow-sm focus:outline-none focus-visible:ring-[#fb680f] focus:ring-[#fb680f] focus:border-[#fb680f] px-2 py-1.5 border w-full border-gray-300 rounded-md",
      ];

      className.push(this.classes);

      return className;
    },
    getId() {
      return this.id ? this.id : this.makeId(4);
    },
  },

  mounted() {},

  methods: {
    makeId(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    /**
     * check prop က parent validator ရဲ့ ရလဒ် — error ရှိရင် message array၊
     * မရှိရင် undefined/false/"" ဖြစ်တယ်။ ဒါကြောင့် empty ဖြစ်နေတာကို
     * "parent က error ကို ရှင်းလိုက်ပြီ" လို့ သတ်မှတ်တယ်။
     */
    isCheckCleared(value) {
      if (value === null || value === undefined || value === false || value === "") {
        return true;
      }

      return Array.isArray(value) && value.length === 0;
    },
    /**
     * validate.js ရဲ့ presence allowEmpty:false က null/"" နှစ်ခုလုံးကို empty လို့
     * သတ်မှတ်ပေမဲ့ v-model ကို ပြန်ထုတ်တဲ့ format တူညီအောင် null အဖြစ်ပဲ ညှိတယ်။
     */
    normalizeValue(value) {
      const trimmedValue =
        value === null || value === undefined ? "" : String(value).trim();

      return trimmedValue.length === 0 ? null : trimmedValue;
    },
    handlerInput(e) {
      // up arrow down arrow နဲ့ value change မရအောင်
      if (this.type == "number" && [38, 40].includes(this.lastKey)) {
        e.target.value = this.modelValue;
      }

      // input type => text မှာ (/\) တွေ ရိုက်လို့မလို့ ပြောင်း စစ်ပေးထားတာ
      if (this.type == "text") { 
          this.filterChars.map((char) => {
          e.target.value = e.target.value
            ? e.target.value.replaceAll(char, "")
            : e.target.value;
        });
      }
      let currentValue = this.normalizeValue(e.target.value);

      this.validate(currentValue);

      if (this.length && e.target.value.length > this.length) {
        e.target.value = this.modelValue;
      } else {
        this.$emit("update:modelValue", currentValue);
        this.$emit(this.event, currentValue);
      }

      if (this.callback) {
        this.callback(currentValue, this.data);
      }

      if (e.target.type === "file") {
        this.$emit("file", e);
      }
    },
    handlerFile(e) {
      if (this.$isServertype == "file") {
        this.$emit("file", e.target.files[0]);
      }
    },
    handleFocusOut(e) {
      this.$emit("focusout", e);
    },
    keyPressHandler(e) {
      this.$emit("key-press", e);
      this.holdNumberInput(e);
    },
    holdNumberInput(e) {
      // if(e.keyCode )
      this.lastKey = e.keyCode;
    },
    validate(value) {
      if (this.rule) {
        this.valid = true;

        let rule = this.rule; //helper.cloneJson(this.rule); // to avoid parent rule object from chaning this rule

        let inputValue = {
          [this.name]: value,
        };

        if (this.forConfirm && this.forConfirm.length > 0) {
          Object.assign(inputValue, { password: this.forConfirm });
          Object.assign(rule.equality, { attribute: "password" });
        }
        let validateStatus = validator(inputValue, { [this.name]: rule });
        this.errorMessage = "";
        if (validateStatus && validateStatus[this.name].length > 0) {
          let message = helper.getErrorMessage(validateStatus);
          this.errorMessage = message ? message : "Invalid!";
          // this.errorMessage = 'Invalid!';
          this.valid = false;
          // this.checkValid(this.locale);
        }
      }
    },
    // checkValid(locale) {

    //   this.$i18n.locale = locale; // locale changing is late so the generated message is reverse

    //   // $(this.$el).siblings("small").remove();
    //   //   // if (!this.valid) {
    //   //   $(this.$el).after($('<small class="c-red-a700 position-absolute">').text(this.errorMessage));
    //   // }
    // }
  },
};
</script>
